import React, { useState, useEffect } from "react";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Icon from "@material-ui/core/Icon";
import { NavLink, useNavigate, useParams } from "react-router-dom";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import TableContainer from "@material-ui/core/TableContainer";
import Pagination from "components/Pagination/Pagination.js";
import AssignStartOtpModal from "views/admin/components/AssignStartOtp/AssignStartOtpModal";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { IconButton } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import axios from "axios";
import Paper from "@material-ui/core/Paper";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { formatDate } from "utils/Utils";

const useStyles = makeStyles(styles);

const statusList = ["ASSIGNED", "INPROCESS", "COMPLETED"];
const submitColumns = ["LOAN ID", "MOBILE", "ADDRESS", "ACTION"];

const FieldAgent = (props) => {
  const classes = useStyles();
  const params = useParams();
  const [showLoanDetails, setShowLoanDetails] = useState(false);
  const [loanDetails, setLoanDetails] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("ASSIGNED");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedPageIndex, setSelectedPageIndex] = useState(1);
  const [tableData, setTableData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [overAllStatus, setOverAllStatus] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [loanApplicationId, setLoanApplicationId] = useState("");
  const [unAssignLoanApplicationId, setUnAssignLoanApplicationId] = useState(
    ""
  );
  const [anchorActionEl, setAnchorActionEl] = useState(null);
  const [showAssignStartotp, setShowAssignStartotp] = useState(false);
  const [assignStartotp, setAssignStartotp] = useState({});
  const closeAssignStartotp = () => {
    setShowAssignStartotp(false);
    setLoanApplicationId("");
    setAssignStartotp({});
  };
  const onAssignStartotp = (loanApplicationId) => {
    setLoanApplicationId(loanApplicationId);
    setShowAssignStartotp(true);
  };

  useEffect(() => {
    GetAllReportsData();
  }, []);
  const GetAllReportsData = async () => {
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    let totalCount = 0;
    statusList.forEach(async (status) => {
      const loanResult = await axios(
        "loan-service/v1/agent/loan/application/assignedTask?status=" + status,
        header
      );
      if (loanResult.data.error_code) {
        console.error(loanResult.data.user_description);
      } else {
        let updatedStatus = overAllStatus;
        const count =
          updatedStatus && updatedStatus[status] && updatedStatus[status].count
            ? updatedStatus[status].count
            : 0;
        updatedStatus[status] = loanResult.data;
        totalCount = totalCount + +updatedStatus[status].count - +count;
        setTotalCount(totalCount);
        setOverAllStatus(updatedStatus);
        showLoanRecords(selectedStatus);
      }
    });
  };
  const showLoanRecords = (status) => {
    setSelectedStatus(status);
    let applications = overAllStatus[status];
    setTableColumns(submitColumns);
    parseIndicatorData(status, applications);
  };

  const parseIndicatorData = (status, data) => {
    let reportData = [];
    data &&
      data.applications &&
      data.applications.forEach((goldpay, index) => {
        if (status === "ASSIGNED") {
          reportData.push([
            index,
            getLoanDetailsLink(goldpay.id, goldpay.loanRequestNum),
            goldpay.mobileNumber?.trim(),
            goldpay.address,
            getStartLink(goldpay.id),
          ]);
        } else if (status === "INPROCESS") {
          reportData.push([
            index,
            getLoanDetailsLink(goldpay.id, goldpay.loanRequestNum),
            goldpay.mobileNumber?.trim(),
            goldpay.address,

            getActionLink(goldpay.id, goldpay.loanApplicationNumber),
          ]);
        } else {
          reportData.push([
            index,
            getLoanDetailsLink(goldpay.id, goldpay.loanRequestNum),
            goldpay.mobileNumber?.trim(),
            goldpay.address,
          ]);
        }
        // } else {
        //     reportData.push([
        //         getLoanDetailsLink(goldpay.id, goldpay.loanRequestNum),
        //         goldpay.proposedLoanAmt,
        //         goldpay.branchName,
        //         goldpay.agentName,
        //         formatDate(goldpay.createdOn),
        //     ]);
        // }
      });
    let selectedList = reportData.slice(
      (selectedPageIndex - 1) * rowsPerPage,
      selectedPageIndex * rowsPerPage
    );
    setSelectedTableData(selectedList);
    setTableData(reportData);
  };
  const getActionLink = (loanApplicationId, loanApplicationNumber) => {
    return (
      <>
        <Button
          size="small"
          color="info"
          className="bg-gradient-theme-left border-0"
          aria-label="download report"
          onClick={(event) => onActionClickReject(event, loanApplicationId)}
        >
          Reject
        </Button>
        <Button
          size="small"
          color="info"
          className="bg-gradient-theme-left border-0"
          aria-label="download report"
          onClick={(event) =>
            onActionClickContinue(
              event,
              loanApplicationId,
              loanApplicationNumber
            )
          }
        >
          Continue
        </Button>
      </>
    );
  };

  const getStartLink = (loanApplicationId) => {
    return (
      <>
        <Button
          size="small"
          color="info"
          className="bg-gradient-theme-left border-0"
          aria-label="download report"
          onClick={(event) =>
            onActionClickAssignedStart(event, loanApplicationId)
          }
        >
          Start
        </Button>
      </>
    );
  };

  // const onActionClickAssignedDetails = async (event, loanApplicationId) => {
  //     const header = {
  //         headers: {
  //             Authorization: 'Bearer ' + localStorage.getItem('token'),
  //         },
  //     };

  //     let response = await axios.get('loan-service/v1/customer/loan/application/find?id=' + loanApplicationId, header);
  //     console.log(response.data);

  //     // navigation.navigate(LOANREQUEST_SCREEN);

  // }
  const onActionClickAssignedStart = async (event, loanApplicationId) => {
    const data = {
      loanApplicationId: loanApplicationId,
    };
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    let response = await axios.put(
      "loan-service/v1/agent/loan/application/startTask",
      data,
      header
    );
    // navigation.navigate(LOANREJECT_SCREEN);
    // alert("Application Reject")
    onAssignStartotp(loanApplicationId);
  };
  const onActionClickReject = async (event, loanApplicationId) => {
    const data = {
      loanApplicationId: loanApplicationId,
      reason: "Not Interested",
      text: "Update by Field Agent",
    };
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    let response = await axios.post(
      "loan-service/v1/agent/loan/application/reject",
      data,
      header
    );
    // navigation.navigate(LOANREJECT_SCREEN);
    alert("Application Reject");
    GetAllReportsData();
  };
  const onActionClickContinue = async (
    event,
    loanApplicationId,
    loanApplicationNumber
  ) => {
    localStorage.setItem("lpn", loanApplicationNumber);
    props.navigate("/admin/applicant/" + loanApplicationId);
  };
  const getLoanDetailsLink = (loanApplicationId, link) => {
    return link !== "" ? (
      <span
        style={{ cursor: "pointer" }}
        onClick={() => onLoanDetails(loanApplicationId)}
      >
        {link}
      </span>
    ) : null;
  };
  const handleActionMenuClose = () => {
    setAnchorActionEl(null);
  };
  const onActionClick = (event, loanApplicationId) => {
    setAnchorActionEl(event.currentTarget);
    setUnAssignLoanApplicationId(loanApplicationId);
  };
  const unAssignLoanApplication = async () => {
    handleActionMenuClose();
    const data = {
      loanApplicationId: unAssignLoanApplicationId,
    };
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    let response = await axios.post(
      "loan-service/v1/admin/loan/application/unassign",
      data,
      header
    );
    setUnAssignLoanApplicationId("");
    GetAllReportsData();
  };
  const onLoanDetails = async (loanApplicationId) => {
    // Get Loan Application Details
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const result = await axios(
      "loan-service/v1/customer/loan/application/find?id=" + loanApplicationId,
      header
    );
    // Loan Details Modal
    setLoanDetails(result.data);
    setShowLoanDetails(true);
  };
  const closeLoanModal = () => {
    setShowLoanDetails(false);
    setLoanDetails({});
  };
  // message popup
  const getPageData = (event) => {
    let pageIndex = 0;
    let pageCount = Math.ceil(tableData.length / rowsPerPage);
    switch (event.target.innerText) {
      case "FIRST":
        pageIndex = 1;
        break;
      case "PREVIOUS":
        pageIndex = selectedPageIndex - 1;
        break;
      case "LAST":
        pageIndex = pageCount;
        break;
      case "NEXT":
        pageIndex = selectedPageIndex + 1;
        break;
      default:
        pageIndex = parseInt(event.target.innerText);
        break;
    }
    if (pageIndex < 1) pageIndex = 1;
    else if (pageIndex > pageCount) pageIndex = pageCount;

    let selectedList = tableData.slice(
      (pageIndex - 1) * rowsPerPage,
      pageIndex * rowsPerPage
    );
    setSelectedPageIndex(pageIndex);
    setSelectedTableData(selectedList);
  };
  const getPageDetails = () => {
    let DataCount = Math.ceil(tableData.length / rowsPerPage);
    // switch ()
    let pageArray = [];
    Array.from(new Array(DataCount)).forEach((count, index) => {
      if (index + 1 === selectedPageIndex) {
        pageArray.push({
          text: `${index + 1}`,
          active: true,
        });
      } else {
        pageArray.push({
          text: `${index + 1}`,
        });
      }
    });
    return pageArray;
  };
  const getOverAllStatusCards = () => {
    return statusList.map((status, index) => {
      return (
        <GridItem xs={12} sm={6} md={2}  key={index}>
          <Card
            style={{ cursor: "pointer" }}
            onClick={() => showLoanRecords(status)}
          >
            <CardHeader color="warning" stats icon>
              <h3
                className={classes.cardCategory}
                style={{
                  fontWeight: selectedStatus === status ? "bold" : "normal",
                }}
              >
                {status}
              </h3>
              <h3 className={classes.cardTitle}>
                {overAllStatus &&
                overAllStatus[status] &&
                overAllStatus[status].count
                  ? overAllStatus[status].count
                  : 0}
                /{totalCount}
              </h3>
            </CardHeader>
          </Card>
        </GridItem>
      );
    });
  };
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <h3 style={{ fontWeight: 500 }}>FieldAgent</h3>
        </GridItem>
        {getOverAllStatusCards()}
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer component={Paper}>
            <Table
              tableHeaderColor="warning"
              tableHead={tableColumns}
              tableData={selectedTableData}
            />
            <div style={{ textAlign: "right" }}>
              <Pagination
                pages={getPageDetails()}
                currentPage={selectedPageIndex}
                color="info"
                onClick={(event) => getPageData(event)}
              />
            </div>
          </TableContainer>
          <Menu
            id="action-menu"
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            MenuListProps={{
              style: {
                border: "1px solid #d3d4d5",
                borderRadius: "3px",
                boxShadow:
                  "0 2px 5px 0 rgba(' + hexToRgb(blackColor) + ', 0.26)",
              },
            }}
            anchorEl={anchorActionEl}
            keepMounted
            open={Boolean(anchorActionEl)}
            onClose={() => handleActionMenuClose()}
          >
            <MenuItem onClick={() => unAssignLoanApplication()}>
              {"UnAssign"}
            </MenuItem>
          </Menu>
        </GridItem>
        {showAssignStartotp && (
          <AssignStartOtpModal
            showModal={showAssignStartotp}
            trade={assignStartotp}
            closeModal={closeAssignStartotp}
            loanApplicationId={loanApplicationId}
          />
        )}
      </GridContainer>
    </div>
  );
};

export default FieldAgent;
